import { Grid } from '@material-ui/core'

import { Loader } from '@percent/admin-dashboard/common/components'
import { useQuery, useRequiredParams } from '@percent/admin-dashboard/common/hooks'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { DonationRequestsDetails } from './DonationRequestDetails/DonationRequestDetails'

export function DonationRequestDetailContainer() {
  const { donationRequestsService } = useServices()
  const { id } = useRequiredParams()
  const [{ data, isLoading }, { refresh }] = useQuery(donationRequestsService.getEnhanced, {
    id
  })

  if (isLoading) {
    return <Loader />
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <DonationRequestsDetails data={data} refresh={refresh} />
      </Grid>
    </Grid>
  )
}
